import { AvailableFeatureFlag, FeatureFlagService } from "../feature-flag-service";

export function useFeature(featureName: AvailableFeatureFlag): boolean {
  return FeatureFlagService.isEnabled(featureName);
}
